import { EntityCollectionBlock } from "@/features/feature-page/entity-collection-block";
import { EntitySpotlightBlock } from "@/features/feature-page/entity-spotlight-block";
import { FactGridBlock } from "@/features/feature-page/fact-grid-block";
import { GalleryBlock } from "@/features/feature-page/gallery-block";
import { HeroBlock } from "@/features/feature-page/hero-block";
import { PullQuoteBlock } from "@/features/feature-page/pull-quote-block";
import { RelatedPagesBlock } from "@/features/feature-page/related-pages-block";
import { RichTextBlock } from "@/features/feature-page/rich-text-block";
import { SearchCtaBlock } from "@/features/feature-page/search-cta-block";
import { SourcesBlock } from "@/features/feature-page/sources-block";
import { TimelineBlock } from "@/features/feature-page/timeline-block";
import type {
  FeaturePageRenderModel,
  ResolvedFeaturePageBlock,
} from "@garimpa/api/featurePages/types";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function FeaturePageBlock({
  block,
  sources,
  locale,
  heroPresentation = "editorial",
}: {
  block: ResolvedFeaturePageBlock;
  sources: FeaturePageRenderModel["sources"];
  locale: ViewerLocale;
  heroPresentation?: "directory" | "editorial";
}) {
  switch (block.type) {
    case "hero":
      return <HeroBlock block={block} compact={heroPresentation === "directory"} />;
    case "richText":
      return <RichTextBlock block={block} />;
    case "entitySpotlight":
      return <EntitySpotlightBlock block={block} />;
    case "entityCollection":
      return <EntityCollectionBlock block={block} />;
    case "factGrid":
      return <FactGridBlock block={block} />;
    case "timeline":
      return <TimelineBlock block={block} />;
    case "gallery":
      return <GalleryBlock block={block} />;
    case "pullQuote":
      return <PullQuoteBlock block={block} />;
    case "relatedPages":
      return <RelatedPagesBlock block={block} locale={locale} />;
    case "searchCta":
      return <SearchCtaBlock block={block} />;
    case "sources":
      return <SourcesBlock block={block} sources={sources} />;
  }
}
